module.exports = __webpack_public_path__ + "media/images/star-d4f2f1ef7e3704170b2ce5f5f92f8219.svg";